import React, { useState } from "react";
import FDLisitingCard from "@/app/alts/fd/components/fd-listing-card";
import { FDProduct } from "@/app/interface/fd";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
// import { initBranch, trackEvent } from "@/app/utils/branchio";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { useCleverTapEvents } from "@/app/hooks/use-clevertap";

interface FDLisitingCardsProps {
    fdData: FDProduct[];
    isFDLoading: boolean;
    isFdFetched: boolean;
}

const FDLisitingCards: React.FC<FDLisitingCardsProps> = ({ fdData, isFDLoading }) => {
    const [showAll, setShowAll] = useState(false);
    const { cleverTapTrackEvent } = useCleverTapEvents();

    const activeFDs = fdData
        ?.filter((fd) => fd.isActive)
        ?.sort((a, b) => {
            return a.order - b.order;
        });

    const shouldShowButton = activeFDs?.length > 6;
    const visibleFDs = showAll ? activeFDs : activeFDs?.slice(0, 6);

    const handleViewAllClick = () => {
        const newShowAll = !showAll;
        setShowAll(newShowAll);

        if (newShowAll) {
            cleverTapTrackEvent("FD_View_All", {});
            // initBranch()
            //     .then(() => {
            //         trackEvent("FD_View_All", "", "");
            //     })
            //     .catch((error) => console.error("Error initializing Branch:", error));

            setAnalyticsEvent(window.location.origin, "FD_View_All");
        }
    };

    return (
        <div id="fd-listing-section" className="relative mx-auto max-w-[928px] px-[25px] md:px-0">
            <div className="grid grid-cols-2 gap-3 md:gap-6">
                {isFDLoading
                    ? Array.from({ length: 6 }).map((_, index) => (
                          <div
                              key={index}
                              className="border-neutralOpacityLight-8 relative flex w-full animate-pulse flex-col items-center justify-between gap-s7 rounded-lg border px-s7 pb-s7 pt-s11 md:flex-row md:gap-6 md:p-6"
                          >
                              {/* Tagline Skeleton */}
                              <div className="absolute left-s7 top-[5px] h-5 w-24 rounded-lg bg-gray-300 md:left-6 md:top-0"></div>

                              {/* Left Section Skeleton */}
                              <div className="flex flex-grow flex-col items-center gap-4 md:flex-row">
                                  {/* Logo */}
                                  <div className="relative mb-4 h-[56px] w-full flex-shrink-0 overflow-hidden rounded-md border border-gray-200 bg-gray-300 md:mb-0 md:h-[72px] md:w-[72px]"></div>

                                  {/* Name */}
                                  <div className="h-6 w-32 rounded bg-gray-300"></div>
                              </div>

                              {/* Right Section Skeleton */}
                              <div className="flex w-full flex-col items-start gap-4 md:w-[155px] md:flex-row md:items-center">
                                  {/* Interest Rate */}
                                  <div className="space-y-1">
                                      <div className="h-3 w-10 rounded bg-gray-300"></div>
                                      <div className="h-10 w-20 rounded bg-gray-300"></div>
                                      <div className="h-3 w-16 rounded bg-gray-300"></div>
                                  </div>

                                  {/* Icon Button Placeholder */}
                                  <div className="h-10 w-10 rounded-full bg-gray-300"></div>
                              </div>
                          </div>
                      ))
                    : visibleFDs?.map((fd) => (
                          <FDLisitingCard
                              key={`${fd.product}-${fd.productType}`}
                              id={`fd-card-${fd.product}`}
                              fdName={fd?.displayName}
                              fdLogo={fd?.logoUrl}
                              interestRate={
                                  Number(fd?.maxReturns?.returns) +
                                  Number(fd?.maxReturns?.seniorCitizenBenefits)
                              }
                              tagLine={fd?.productTagLine}
                              productType={fd?.productType}
                              product={fd?.product}
                          />
                      ))}
            </div>
            {shouldShowButton && (
                <div className="flex w-full justify-center">
                    <RegularButton
                        id="fd-show-all-button"
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Medium}
                        variant={ButtonVariant.SecondaryDefault}
                        className="mx-auto my-6 w-full md:w-fit"
                        label={showAll ? "Show Less" : "View All FDs"}
                        onClick={handleViewAllClick}
                    />
                </div>
            )}
        </div>
    );
};

export default FDLisitingCards;
